import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { organizationNames } from "constants/phase";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectSelectedEntityName } from "store/entity/selectors";

import AppV1 from "../../app/App";
import SessionStorage from "../../utils/SessionStorage";
import AppV2 from "./AppV2";
import styles from "./style.module.css";

const App = ({ entityName }) => {
  const [isAppLoading, setIsAppLoading] = useState(true);
  const [isNewVersionEnabled, setIsNewVersionEnabled] = useState(false);
  const versionState = SessionStorage.getItem("isNewVersionEnabled");

  useEffect(() => {
    setIsAppLoading(true);
    try {
      if (!versionState && entityName !== organizationNames.ZEE_AUTO_SHOW) {
        setIsNewVersionEnabled(true);
      } else {
        setIsNewVersionEnabled(versionState === "true");
      }
      if (entityName === organizationNames.ZEE_AUTO_SHOW) {
        SessionStorage.setItem("isNewVersionEnabled", false);
      }
    } catch (error) {
      console.error(error);
    }
    setIsAppLoading(false);
  }, [versionState, entityName]);

  if (isAppLoading) {
    return <Spin indicator={<LoadingOutlined spin />} className={styles.fullScreenLoader} />;
  }

  if (isNewVersionEnabled) {
    return <AppV2 />;
  }

  return <AppV1 />;
};

const mapStateToProps = createStructuredSelector({
  entityName: selectSelectedEntityName,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(App);
